import { Typography } from "antd";
import { Flex } from "common/components/flex/flex";
import { InfoIcon } from "common/icons/InfoIcon";
import { Tooltip } from "common/components/tooltip/tooltip";
import styles from "features/dashboard/sections/tasks/tasksContent/taskGroup/taskGroupHeader/taskGroupHeader.module.scss";

export const TaskGroupHeader = ({ testId, icon, label, description, count }) => (
  <div className={styles.taskGroupHeader}>
    <Flex justify="space-between" align="center">
      <Flex align="center" gap={8}>
        <span className={styles.taskGroupHeader__icon}>{icon}</span>
        <Typography.Text className="font-weight-medium">
          {label}
        </Typography.Text>
      </Flex>

      <Flex align="center" gap={8}>
        <Tooltip title={description}>
          <InfoIcon
            className={`text-primary-accent ${styles.taskGroupHeader__infoIcon}`}
            data-testid={`task-info-icon-${testId}`}
          />
        </Tooltip>
        <span className={styles.taskGroupHeader__count}>
          <span>{count}</span>
        </span>
      </Flex>
    </Flex>
  </div>
);
